import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("desc", null, " Synchronize Arrow Clock Streamline Icon: https://streamlinehq.com ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13 6a1 1 0 0 0 -1 1v5.5a1 1 0 0 0 1 1h5a1 1 0 0 0 0 -2h-3.79a0.25 0.25 0 0 1 -0.25 -0.25V7A1 1 0 0 0 13 6Z",
    fill: "#dbdbdb",
    "stroke-width": "1"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.57 1.26A10.81 10.81 0 0 0 2.82 8.4a0.25 0.25 0 0 1 -0.27 0.16L0.86 8.31a0.52 0.52 0 0 0 -0.49 0.21 0.51 0.51 0 0 0 0 0.53L3 13.75a0.51 0.51 0 0 0 0.4 0.25 0.53 0.53 0 0 0 0.42 -0.14l3.77 -3.75a0.5 0.5 0 0 0 -0.28 -0.85L5.59 9a0.26 0.26 0 0 1 -0.18 -0.13 0.24 0.24 0 0 1 0 -0.22 8.26 8.26 0 1 1 7.87 11.59 1.25 1.25 0 1 0 0.09 2.5 10.75 10.75 0 0 0 -0.79 -21.49Z",
    fill: "#dbdbdb",
    "stroke-width": "1"
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'synchronizaIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#dbdbdb",
  },
  width: {
    type: Number as PropType<number>,
    default: 16,
  },
  height: {
    type: Number as PropType<number>,
    default: 16,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    id: "Synchronize-Arrow-Clock--Streamline-Ultimate.svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: __props.width,
    height: __props.height
  }, _hoisted_4, 8, _hoisted_1))
}
}

})